import { html } from "@microsoft/fast-element";
export const searchIcon = html `
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7291 13.4362C11.5924 14.411 10.115 15 8.5 15C4.91015 15 2 12.0899 2 8.5C2 4.91015 4.91015 2 8.5 2C12.0899 2 15 4.91015 15 8.5C15 10.115 14.411 11.5924 13.4361 12.7292L16.8535 16.1465C17.0487 16.3417 17.0487 16.6583 16.8535 16.8536C16.6799 17.0271 16.4105 17.0464 16.2156 16.9114L16.1464 16.8536L12.7291 13.4362ZM12.0196 12.7266C12.276 12.5128 12.5127 12.2761 12.7265 12.0197C13.5216 11.0659 14 9.83881 14 8.5C14 5.46243 11.5376 3 8.5 3C5.46243 3 3 5.46243 3 8.5C3 11.5376 5.46243 14 8.5 14C9.83877 14 11.0658 13.5217 12.0196 12.7266Z"
      fill="#616161"
    />
  </svg>
`;
export const dismissIcon = html `
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.08859 4.21569L4.14645 4.14645C4.32001 3.97288 4.58944 3.9536 4.78431 4.08859L4.85355 4.14645L10 9.293L15.1464 4.14645C15.32 3.97288 15.5894 3.9536 15.7843 4.08859L15.8536 4.14645C16.0271 4.32001 16.0464 4.58944 15.9114 4.78431L15.8536 4.85355L10.707 10L15.8536 15.1464C16.0271 15.32 16.0464 15.5894 15.9114 15.7843L15.8536 15.8536C15.68 16.0271 15.4106 16.0464 15.2157 15.9114L15.1464 15.8536L10 10.707L4.85355 15.8536C4.67999 16.0271 4.41056 16.0464 4.21569 15.9114L4.14645 15.8536C3.97288 15.68 3.9536 15.4106 4.08859 15.2157L4.14645 15.1464L9.293 10L4.14645 4.85355C3.97288 4.67999 3.9536 4.41056 4.08859 4.21569L4.14645 4.14645L4.08859 4.21569Z"
      fill="#616161"
    />
  </svg>
`;
//# sourceMappingURL=component-svgs.js.map